import React, { useState, useEffect } from 'react';
import { LockScreen } from './components/LockScreen';
import { Dashboard } from './components/Dashboard';
import { isAuthenticated, clearAuthentication } from './utils/auth';

export const App: React.FC = () => {
  const [isUnlocked, setIsUnlocked] = useState<boolean>(false);
  const [isChecking, setIsChecking] = useState<boolean>(true);

  useEffect(() => {
    // Check initial auth status on mount
    const authed = isAuthenticated();
    setIsUnlocked(authed);
    setIsChecking(false);
  }, []);

  const handleUnlock = () => {
    setIsUnlocked(true);
  };

  const handleLock = () => {
    clearAuthentication();
    setIsUnlocked(false);
  };

  if (isChecking) {
    return (
      <div className="min-h-screen bg-[#080c14] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-tiger-500/20 border-t-tiger-500 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#080c14] text-slate-100 selection:bg-tiger-500 selection:text-white">
      {isUnlocked ? (
        <Dashboard onLock={handleLock} />
      ) : (
        <LockScreen onUnlock={handleUnlock} />
      )}
    </div>
  );
};

export default App;
